
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
    name: 'SwiperItem',
})
export default class SwiperItem extends Vue {
    get width() {
        return this.$parent?.$data.currentWidth + 'px';
    }

    private created() {
        (this.$parent?.$data.child as any[]).push(this);
    }
}
